import styled from 'styled-components';
import { Container } from '../../styles/Common';

const Header = () => {
  return (
    <Container>
      <Wrapper>
        <Heading>Email Marketing , SMS Marketing E-COMMERCE</Heading>
        <Paragraph>
          Email and SMS retention marketing is pivotal for any business. There
          are 4 billion daily email users. 5 billion daily sms users.
        </Paragraph>
        <SpeakWithExpertButton
          href="https://calendly.com/info-ripify"
          target="_blank"
        >
          <span className="text">SPEAK WITH AN EXPERT</span>
        </SpeakWithExpertButton>
      </Wrapper>
    </Container>
  );
};

export default Header;

const Wrapper = styled.div`
  padding: 85px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 576px) {
    padding: 45px 0;
  }
`;

const Heading = styled.h1`
  margin: 0 auto 20px auto;
  max-width: 25ch;
  font-weight: 700;
  font-family: font-bold;
  font-size: 55px;
  text-align: center;
  line-height: 1.4;
  background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 576px) {
    font-size: 32px;
  }
`;

const Paragraph = styled.p`
  margin: 0 auto 35px auto;
  max-width: 75ch;
  font-weight: 500;
  font-family: font-medium;
  font-size: 18px;
  text-align: center;
  line-height: 1.8;
  color: #989fb3;
`;

const SpeakWithExpertButton = styled.a<any>`
  margin-top: 35px;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 8;
  background: linear-gradient(
    96.91deg,
    #5ca6ed 0%,
    #5f60ef 48.46%,
    #b174f8 100%
  );
  height: 77px;
  width: 300px;
  font-family: font-medium;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 3px;

  &:after {
    position: absolute;
    content: '';
    z-index: 9;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      96.91deg,
      #5ca6ed 0%,
      #5f60ef 48.46%,
      #b174f8 100%
    );
    transform: rotate(180deg);
    opacity: 0;
    transition: 0.3s;
  }

  .text {
    font-family: font-medium;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    transition: 0.3s;
    letter-spacing: 3px;
    position: relative;
    z-index: 10;
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`;
